export const nomadLocations = [
  {
    id: 'hudson-valley',
    label: 'Hudson Valley, New York',
    subtitle: 'Hometown',
    x: 35,
    y: 19,
    accent: 'var(--accent-star)',
  },
  {
    id: 'Rio de Janeiro',
    label: 'Rio de Janeiro, Brazil',
    subtitle: 'Many Family Visits',
    x: 58,
    y: 52,
    accent: 'var(--accent-pearl)',
  },
  {
    id: 'eastern-belgium',
    label: 'Wallonie, Belgium',
    subtitle: 'Rotary Exchange',
    x: 73,
    y: 21,
    accent: 'var(--accent-amethyst)',
  },
  {
    id: 'nyc',
    label: 'New York City, New York',
    subtitle: 'NYC Chapter',
    x: 35,
    y: 23,
    accent: 'var(--accent-sapphire)',
  },
  {
    id: 'providence',
    label: 'Providence, Rhode Island',
    subtitle: 'Software Engineering Program',
    x: 39,
    y: 21,
    accent: 'var(--accent-teal)',
  },
  {
    id: 'boston',
    label: 'Boston, Massachusetts',
    subtitle: 'Moved for Wayfair',
    x: 39,
    y: 20,
    accent: 'var(--accent-pearl)',
  },
  {
    id: 'northeastern-ct',
    label: 'Northeastern Connecticut, USA',
    subtitle: 'Country Life',
    x: 36,
    y: 21,
    accent: 'var(--accent-emerald)',
  },
  {
    id: 'eastern-puerto-rico',
    label: 'Eastern Puerto Rico',
    subtitle: 'Island Life',
    x: 35,
    y: 38,
    accent: 'var(--accent-star)',
  },
];
